const DotSvg = (props: any) => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <rect
      x={0.5}
      y={0.5}
      width={11}
      height={11}
      rx={5.5}
      fill={props.background}
      stroke="#FE724C"
    />
  </svg>
)

export default DotSvg
